import { fetchAPI, API_BASE_URL } from "./apiCore";
import { getToken, getuserId } from "./auth";


// Fetch all encounters with nested patient, studies, and consents data
// export const fetchAllEncounters = async () => {
//   try {
//     console.log("🌐 API: Fetching encounters with nested data");
//     const result = await fetchAPI("biobank/encounters", "GET");
//     return result;
//   } catch (error) {
//     console.error("❌ API: Error fetching encounters:", error);
//     return [];
//   }
// };


/**
 * Unified streamlined worklist API for both scheduling and check-in pages.
 * Returns only essential fields with consent status properly calculated.
 * This is the RECOMMENDED API to use for worklist views.
 */
export const fetchEncounterWorklist = async (page = 0, size = 25, filters = {}) => {
  try {
    const queryParams = Object.entries({
      page,
      size,
      ...filters,
    }).reduce((acc, [key, value]) => {
      if (value !== null && typeof value !== "undefined" && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    const result = await fetchAPI(
      "biobank/encounters/worklist",
      "GET",
      queryParams,
    );

    return result;
  } catch (error) {
    console.error("❌ API: Error fetching encounter worklist:", error);
    return { content: [], totalElements: 0 };
  }
};

/**
 * @deprecated Use fetchEncounterWorklist instead for better performance and correct consent status calculation.
 */
export const fetchEncountersPaged = async (page = 0, size = 20, filters = {}) => {
  try {
    const queryParams = Object.entries({
      page,
      size,
      ...filters,
    }).reduce((acc, [key, value]) => {
      if (value !== null && typeof value !== "undefined" && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    const result = await fetchAPI(
      "biobank/encounters/paged",
      "GET",
      queryParams,
    );

    return result;
  } catch (error) {
    console.error("❌ API: Error fetching encounters:", error);
    return { content: [] };
  }
};

/**
 * @deprecated Use fetchEncounterWorklist instead for better performance and correct consent status calculation.
 */
export const fetchCheckInWorklist = async (page = 0, size = 25, filters = {}) => {
  try {
    const queryParams = Object.entries({
      page,
      size,
      ...filters,
    }).reduce((acc, [key, value]) => {
      if (value !== null && typeof value !== "undefined" && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    const result = await fetchAPI(
      "biobank/check-in/worklist",
      "GET",
      queryParams,
    );

    return result;
  } catch (error) {
    console.error("❌ API: Error fetching check-in worklist:", error);
    return { content: [] };
  }
};


// Fetch sample collection worklist (new API)
export const fetchSampleCollectionWorklist = async (filters = {}) => {
  try {
    const queryParams = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value !== null && typeof value !== "undefined" && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});
    console.log("🌐 API: Fetching sample collection worklist", queryParams);
    const result = await fetchAPI(
      "biobank/sample-collection/worklist",
      "GET",
      queryParams,
    );
    console.log("✅ API: Sample collection worklist:", result);
    return result;
  } catch (error) {
    console.error("❌ API: Error fetching sample collection worklist:", error);
    return { content: [], totalElements: 0, pageNumber: 0, pageSize: 20 };
  }
};

// Fetch encounters that are checked-in and pending sample collection (deprecated)
export const fetchPendingCollectionEncounters = async (type = null, filters = {}) => {
  try {
    const queryParams = Object.entries({
      ...(type ? { type } : {}),
      ...filters,
    }).reduce((acc, [key, value]) => {
      if (value !== null && typeof value !== "undefined" && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});
    console.log("🌐 API: Fetching pending collection encounters", queryParams);
    const result = await fetchAPI(
      "biobank/encounters/pending-collection",
      "GET",
      queryParams,
    );
    console.log("✅ API: Pending collection encounters:", result);
    return result;
  } catch (error) {
    console.error("❌ API: Error fetching pending collection encounters:", error);
    return [];
  }
};


// Create encounter (scheduled patient table display)
export const createEncounter = async (payload) => {
  return await fetchAPI("biobank/encounters", "POST", {}, payload);
};

export const fetchEncounterById = async (encounterId) => {
  try {
    return await fetchAPI(
      `biobank/encounters/${encodeURIComponent(encounterId)}`,
      "GET"
    );
  } catch (error) {
    console.error("Error fetching encounter:", error);
    return null;
  }
};


//updateEncounter
export const updateEncounter = async (encounterId, payload) => {
  return fetchAPI(`biobank/encounters/${encounterId}`, "PATCH", {}, payload);
};

export const updateEncounterTime = async (encounterId, payload) => {
  return fetchAPI(`biobank/encounters/${encounterId}/time`, "PATCH", {}, payload);
};


export const checkInEncounterV2 = async (encounterId, payload = {}) => {
  const body =
    payload && Object.keys(payload).length > 0 ? payload : null;

  return fetchAPI(
    `biobank/encounters/${encodeURIComponent(encounterId)}/check-in/v2`,
    "POST",
    {},
    body,
  );
};


export const ensureFollowUpEncounter = async (followUpId) => {
  return fetchAPI(`biobank/follow-ups/${encodeURIComponent(followUpId)}/ensure-encounter`, "POST");
};
